export default __webpack_public_path__ + "static/media/leandustry.ad4003f7.webp";